import {NavLink} from 'react-router-dom';

import './Home.css';
import Footer from '../components/Footer.js';
import Header from '../components/Header.js';


import img1 from '../media/images/Middle_Pack.jpg'


function Home() {
    return (
      <div className='Home-screen'>
        <Header></Header>
        <main className='main-container'  >

            {/* <div className='Paragraph-2'>
                <h2 className='slogan-2'  >Your Fresh <br />Arrangements <br /> Start Here</h2>
            </div> */}

            <div class = 'imag-1'><img  src={img1} alt="Large Decorated Fruit Plates"></img></div>
            <div className='Paragraph'>
                <NavLink className = 'link' to='/order' >
                <button className='button'>ORDER NOW</button>
                </NavLink>
            </div>
         

        </main>
        <div className='footer-test'>
       <Footer></Footer>
       </div>
      </div>
    );
  }
  
  export default Home;

